import { createContext, useContext, useEffect, useState } from "react";
import { useInterval } from "../hooks/useInterval";
import Swal from "sweetalert2";
import { useMsal } from "@azure/msal-react";
import { UserContext } from "./UserContext";
import { UrlContext } from "./UrlContext";
import io from "socket.io-client";

// import io from "socket.io-client";

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [projects, setProjects] = useState([]);
  const [projectWithFilter, setProjectWithFilter] = useState([]);
  const [error, setError] = useState(null);
  const [users, setUsers] = useState([]);
  const [owners, setOwners] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [topConsultant, setTopConsultant] = useState([]);
  const [totalConsultant, setTotalConsultant] = useState({});
  const [updateProjects, setUpdateProjects] = useState(false);
  const [listOverview, setListOverview] = useState([]);
  const { instance } = useMsal();
  const [allProjects, setAllProjects] = useState([]);
  const [allCustomisedLists, setAllCustomisedLists] = useState([]);
  const { API_URL } = useContext(UrlContext);
  const [sanitize, setSanitize] = useState(false);
  const [stopLoading, setStopLoading] = useState(false);
  const [searchData, setSearchData] = useState({
    profile_type: "",
    search_type: "entireDatabase",
    position: "",
    region: "",
    country: "",
    keywords: "",
    company: "",
    more_profiles: "",
    project_id: "",
    buttonClicked: "",
    companyType: "both",
    searchingFrom: "",
    profileIDList: [],
  });
  const ephToken = localStorage.getItem("eph-token");
  const token = JSON.parse(ephToken).value;
  const [applications, setApplications] = useState([]);
  const [allRequests, setAllRequests] = useState([]);
  const [queAnswers, setQueAnswers] = useState([]);
  const { updateApplication } = useContext(UserContext);
  const [aiSearchResults, setAiSearchResults] = useState({});
  const [allEmails, setAllEmails] = useState([]);
  const [allExpertSuggestions, setAllExpertSuggestions] = useState([]);

  useEffect(() => {
    checkLogin();
  }, []);

  useEffect(() => {
    setLoading(true);
    const tokenObj = localStorage.getItem("eph-token");
    const token = JSON.parse(tokenObj).value;
    const getProjects = async () => {
      const url = `${API_URL}projects-overview/${page}`;
      await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
      })
        .then((res) => res.json())
        .then((data) => {
          setProjects(data.data);
          setLoading(false);
          if (data.data.length < 100) {
            setStopLoading(true);
          }
        })
        .catch((err) => {
          setError(err);
          console.log(err);
        });
    };
    getProjects();
  }, [updateProjects]);

  useEffect(() => {
    const getUsers = async () => {
      const url = `${API_URL}all_project_users`;
      await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => res.json())
        .then((data) => {
          setUsers(data.user_list);
        })
        .catch((err) => {
          setError(err);
          console.log(err);
        });
    };
    const getOwners = async () => {
      const url = `${API_URL}all_project_owners`;
      await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => res.json())
        .then((data) => {
          setOwners(data.owner_list);
        })
        .catch((err) => {
          setError(err);
          console.log(err);
        });
    };

    const getTopConsultant = async () => {
      const url = `${API_URL}top-consultants/1`;
      await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => res.json())
        .then((data) => {
          setLoading(false);
          // if (data.data) {
          //   setTopConsultant([...topConsultant, ...data.data]);
          // }

          if (data.data) {
            setTopConsultant(data.data);
          }
          
          setTotalConsultant({
            total: data.totalTopCon,
            available: data.totalData2,
            twoWeekAvailable: data.totalData1,
          });
        })
        .catch((err) => {
          setLoading(false);
          setError(err);
        });
    };

    getUsers();
    getOwners();
    getTopConsultant();
  }, []);

  useEffect(() => {
    setLoading(true);
    const getMoreProjects = async () => {
      const url = `${API_URL}projects-overview/${page}`;
      await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
      })
        .then((res) => res.json())
        .then((data) => {
          setProjects([...projects, ...data.data]);
          setLoading(false);
        })
        .catch((err) => {
          setError(err);
          console.log(err);
        });
    };
    if (page > 1) getMoreProjects();
  }, [page]);
  useEffect(() => {
    const url = `${API_URL}get-all-projects`;
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setAllProjects(data.projects);
        setAllCustomisedLists(data.customisedLists);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    const resetTimeout = () => {
      localStorage.setItem("timeout", Date.now() + 21600000);
      setTimeout(localStorage.getItem("timeout"));
    };
    const events = ["mousemove", "mousedown", "click", "scroll", "keypress"];
    for (let i in events) {
      window.addEventListener(events[i], resetTimeout);
    }
    return () => {
      for (let i in events) {
        window.removeEventListener(events[i], resetTimeout);
      }
    };
  });

  useEffect(() => {
    const tokenObj = localStorage.getItem("eph-token");
    const token = JSON.parse(tokenObj).value;
    fetch(`${API_URL}get-users-applications`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status == "error") {
          Swal.fire({ title: `${data.message}`, icon: "error" });
        } else {
          setApplications(data?.data);
        }
      })
      .catch((err) => console.log(err));
  }, [updateApplication]);
  // This functions checks if user is logged in and if is time left on the session. If not it will return to login page
  function checkLogin() {
    if (
      localStorage.getItem("eph-token") &&
      Date.now() >= localStorage.getItem("timeout") &&
      !localStorage.getItem("consultantToken")
    ) {
      instance.logoutRedirect();
      localStorage.clear();
      window.location.href = "/";
    }
    if (!localStorage.getItem("eph-token")) {
      window.location.href = "/";
    }
  }
  useInterval(checkLogin, 10000);

  // subscription to socket
  // useEffect(() => {
  //   const socket = io(SOCKET_SERVER_URL);
  //   socket.on("database_disconnect", (data) => {
  //     const error = new Error(`${data.message}`);
  //     setError(error);
  //     setDbConnect(false);
  //   });
  //   //clean socket connection
  //   return () => {
  //     socket.disconnect();
  //   };
  // }, []);
  useEffect(() => {
    if (error) {
      Swal.fire({
        icon: "error",
        title: `${error.message}`,
        text: "connection error.",
        confirmButtonText: "OK",
      });
      console.log(error);
    }
  }, [error]);

  // API to fetch all valid email addresses of experts
  useEffect(() => {
    const fetchAllEmailSuggestions = async () => {
      try {
        const response = await fetch(`${API_URL}get-expert-email-suggestions`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });

        const responseData = await response.json();

        if (responseData.status === "success") {
          setAllEmails(Array.isArray(responseData.emails) ? responseData.emails : []);
        }
      } catch (error) {
        console.error("Error while fetching email suggestions:", error);
      }
    };
    fetchAllEmailSuggestions();
  }, []);

  // API to fetch all experts name for consultant search
  useEffect(() => {
    const controller = new AbortController();

    const fetchAllExpertSuggestions = async () => {
      try {
        const response = await fetch(
          `${API_URL}get-expert-search-suggestions`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
            signal: controller.signal,
          }
        );

        const responseData = await response.json();

        if (!response.ok || responseData.status !== "success") {
          throw new Error(
            responseData.text ||
              `Could not load consultant suggestions (${response.status}).`
          );
        }

        setAllExpertSuggestions(
          Array.isArray(responseData.experts)
            ? responseData.experts
            : []
        );
      } catch (error) {
        if (error.name !== "AbortError") {
          console.error(
            "Error while fetching consultant suggestions:",
            error
          );
        }
      }
    };

    fetchAllExpertSuggestions();

    return () => controller.abort();
  }, [API_URL]);

  return (
    <AppContext.Provider
      value={{
        projects,
        setProjects,
        users,
        owners,
        error,
        setPage,
        page,
        loading,
        topConsultant,
        totalConsultant,
        setUpdateProjects,
        updateProjects,
        API_URL,
        setError,
        listOverview,
        setListOverview,
        allProjects,
        setAllProjects,
        sanitize,
        setSanitize,
        projectWithFilter,
        setProjectWithFilter,
        allCustomisedLists,
        setAllCustomisedLists,
        stopLoading,
        searchData,
        setSearchData,
        applications,
        setApplications,
        allRequests,
        setAllRequests,
        queAnswers,
        setQueAnswers,
        aiSearchResults,
        setAiSearchResults,
        allEmails,
        allExpertSuggestions,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
